<div
  class="card-number-container card-number"
  fxLayout
  fxLayoutAlign="center center"
  #parent
  [ngStyle]="{
    'background-color': changeBackgroundColor ? (card | method: 'getCardColor') || '#F1F2F3' : '#FFFFFF'
  }">
  <div
    class="card-number"
    appFitText
    [parentContainer]="parent"
    [percentageOfParent]="0.55"
    [ngStyle]="{
      color: this | method: 'getAutomaticNumberTextColor'
    }">
    {{ index + (card | method: 'getCardStartAtValue') }}
  </div>
</div>
